import React, { useRef, useState, useEffect } from 'react';
import propTypes from 'prop-types';
;
import { Button, Control, Field, Label } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { UiToastAdapter } from '../logic';
import { getFileInputValue } from '../util';

function getThumb(file) {
  return new Promise((resolve, reject) => {
    if (file) {
      const reader = new FileReader();

      reader.addEventListener('loadend', () => {
        resolve(reader.result);
      });
      reader.addEventListener('error', () => {
        reject(reader.error);
      });
      reader.readAsDataURL(file);
    } else {
      resolve(null);
    }
  });
}

export function UiImageUploader({
  label,
  id,
  name,
  errorMessage,
  onChange,
  value,
  required,
  hideAsterisk,
  ...props
}) {
  const ref = useRef();
  const [thumb, setThumb] = useState(null);

  useEffect(() => {
    async function load() {
      if (value) {
        if (typeof value === 'string') {
          setThumb(value);
        } else {
          try {
            const result = await getThumb(value);
            setThumb(result);
          } catch (error) {
            console.error(error);
            toast(
              UiToastAdapter(
                `Error while reading selected file. (${error.message})`,
                'danger'
              )
            );
            setThumb(null);
          }
        }
      } else {
        setThumb(null);
        if (ref.current) {
          ref.current.value = '';
        }
      }
    }
    load();
  }, [value]);

  const showAsterisk = required && !hideAsterisk;
  const isLink = thumb && thumb.startsWith('http');

  return (
    <Field className="has-floating-label ui-image-uploader">
      <Label htmlFor={id}>
        <span>{label}</span>
        {showAsterisk && (
          <span className="icon is-small has-text-danger asterisk">
            <FontAwesomeIcon icon={['fas', 'asterisk']} size="xs" />
          </span>
        )}
      </Label>
      <Control>
        <div className="image-container">
          <label htmlFor={id} className="button has-text-info">
            <span className="icon is-small">
              <FontAwesomeIcon icon={['fal', 'plus-circle']} />
            </span>
            <span>Upload</span>
          </label>
          {thumb && (
            <div className="thumb">
              <img src={thumb} alt="" />
              <div className="overlay">
                {/* eslint-disable jsx-a11y/anchor-has-content */}
                {isLink && (
                  <a href={thumb} target="_blank" rel="noopener noreferrer" />
                )}
                <FontAwesomeIcon icon={['fal', 'check-circle']} size="3x" />
                <Button className="delete" onClick={() => onChange(null)}>
                  <span className="icon">
                    <FontAwesomeIcon icon={['fas', 'times-square']} />
                  </span>
                </Button>
              </div>
            </div>
          )}
        </div>
      </Control>
      <input
        type="file"
        name={name}
        id={id}
        ref={ref}
        onChange={() => onChange(getFileInputValue(ref))}
        accept="image/*,application/pdf"
        required={required}
        {...props}
      />
    </Field>
  );
}

UiImageUploader.defaultProps = {
  errorMessage: '',
  required: false,
  hideAsterisk: false,
};

UiImageUploader.propTypes = {
  label: propTypes.string.isRequired,
  id: propTypes.string.isRequired,
  name: propTypes.string.isRequired,
  errorMessage: propTypes.string,
  onChange: propTypes.func.isRequired,
  value: propTypes.oneOfType([propTypes.object, propTypes.string]).isRequired,
  required: propTypes.bool,
  hideAsterisk: propTypes.bool,
};
